import dynamic from 'next/dynamic'

export const SideBySide = dynamic(() => import('./side-by-side'))
